import React from 'react';
import styled from 'styled-components';

import { AdviceSection } from './AdviceSection';
import { BarChart } from './BarChart';
import { CardHeader } from './CardHeader';

export interface MonthsData {
  month: string;
  actualPercent: number;
}

interface MonthsStatsCardProps {
  title: string;
  targetPercent: number;
  monthsData: MonthsData[];
  advice: string;
  averageScore: number;
}

const MonthsStatsCard = ({
  title,
  targetPercent,
  monthsData,
  advice,
  averageScore,
}: MonthsStatsCardProps) => {
  return (
    <Card>
      <CardHeader
        title={title}
        targetPercent={targetPercent}
        averageScore={averageScore}
      />
      <BarChart monthsData={monthsData} />
      <AdviceSection advice={advice} />
    </Card>
  );
};

const Card = styled.div`
  border-radius: 4px;
  padding: 40px 20px 20px;
  flex: 1;
  box-shadow: 0 10px 20px 0 #0003;
  background: ${({ theme }) => theme.colors.white};
`;

export default MonthsStatsCard;
